import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { CompanyComparisonComponent } from './company-comparison.component';
var ɵ0 = { title: 'COMPANY_COMPARISON.TITLE' };
var routes = [
    {
        path: 'relatorios/comparar-empresas',
        component: CompanyComparisonComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var CompanyComparisonModule = /** @class */ (function () {
    function CompanyComparisonModule() {
    }
    return CompanyComparisonModule;
}());
export { CompanyComparisonModule };
export { ɵ0 };
